/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.administracion': 'Administración',
  'sidebar.banco': 'Banco',
  'banco.agregarBanco': 'Crear Banco',
  'banco.confirmacionCreacion': '¿Está seguro que desea crear el registro?',
  'banco.confirmacionEdicion': '¿Está seguro que desea editar el registro?',
  'banco.confirmacionEliminacion': '¿Está seguro que desea eliminar el registro?',
  'banco.modificarBanco': 'Editar Banco',
  'banco.codigoBanco': 'Código Banco',
  'banco.nombreBanco': 'Nombre Banco',
  'banco.estadoBanco': 'Estado',
  'banco.verBanco': 'Ver Banco',
  'banco.alerta.codigoInvalido': 'El código de banco ya existe, ingrese uno nuevo',
  'banco.alerta.nombreInvalido': 'El nombre del banco ya existe, ingrese uno nuevo',

};
